import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-slate-900/95 backdrop-blur-md border-b border-slate-800 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Brand Name */}
          <Link to="/" className="flex items-center space-x-2">
          <a href="/">
            <img src="/assets/img/logo-white.png" alt="Trademark IP US" className="h-10" />
          </a>
            {/* <span className="text-2xl font-bold text-white">Trademark IP US</span> */}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors ${
                isActive('/') ? 'text-[#fd5a27]' : 'text-gray-200 hover:text-[#fd5a27]'
              }`}
            >
              Home
            </Link>
            
            {/* Services Dropdown */}
            <div
              className="relative group"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button
                className="text-sm font-medium text-gray-200 hover:text-[#fd5a27] transition-colors flex items-center py-2"
              >
                Services
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform duration-300 ${isServicesOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {isServicesOpen && (
                <div className="absolute left-0 top-full w-72 bg-slate-900 rounded-xl shadow-2xl shadow-[#fd5a27]/20 py-3 border border-slate-700 animate-in fade-in slide-in-from-top-2 duration-300">
                  <Link
                    to="/services/trademark-registration"
                    className="block px-6 py-3 text-sm text-gray-200 hover:bg-slate-800 hover:text-[#fd5a27] transition-all duration-200 rounded-lg mx-2 border-l-2 border-transparent hover:border-[#fd5a27]"
                  >
                    Trademark Registration
                  </Link>
                  <Link
                    to="/services/copyright-registration"
                    className="block px-6 py-3 text-sm text-gray-200 hover:bg-slate-800 hover:text-[#fd5a27] transition-all duration-200 rounded-lg mx-2 border-l-2 border-transparent hover:border-[#fd5a27]"
                  >
                    Copyright Registration
                  </Link>
                  <Link
                    to="/services/company-formation"
                    className="block px-6 py-3 text-sm text-gray-200 hover:bg-slate-800 hover:text-[#fd5a27] transition-all duration-200 rounded-lg mx-2 border-l-2 border-transparent hover:border-[#fd5a27]"
                  >
                    Company Formation
                  </Link>
                  <Link
                    to="/services/trademark-search"
                    className="block px-6 py-3 text-sm text-gray-200 hover:bg-slate-800 hover:text-[#fd5a27] transition-all duration-200 rounded-lg mx-2 border-l-2 border-transparent hover:border-[#fd5a27]"
                  >
                    Trademark Search
                  </Link>
                  <Link
                    to="/services/amazon-brand-registry"
                    className="block px-6 py-3 text-sm text-gray-200 hover:bg-slate-800 hover:text-[#fd5a27] transition-all duration-200 rounded-lg mx-2 border-l-2 border-transparent hover:border-[#fd5a27]"
                  >
                    Amazon Brand Registry
                  </Link>
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors ${
                isActive('/about') ? 'text-[#fd5a27]' : 'text-gray-200 hover:text-[#fd5a27]'
              }`}
            >
              About Us
            </Link>
            
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors ${
                isActive('/contact') ? 'text-[#fd5a27]' : 'text-gray-200 hover:text-[#fd5a27]'
              }`}
            >
              Contact Us
            </Link>
            
            <Button className="js-chat bg-[#fd5a27] hover:bg-[#e04a1f] text-white">
              Live Chat
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-sm font-medium text-gray-200 hover:text-[#fd5a27]"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <div className="text-sm font-medium text-white">Services</div>
              <div className="pl-4 flex flex-col space-y-2">
                <Link
                  to="/services/trademark-registration"
                  className="text-sm text-gray-300 hover:text-[#fd5a27]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Trademark Registration
                </Link>
                <Link
                  to="/services/copyright-registration"
                  className="text-sm text-gray-300 hover:text-[#fd5a27]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Copyright Registration
                </Link>
                <Link
                  to="/services/company-formation"
                  className="text-sm text-gray-300 hover:text-[#fd5a27]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Company Formation
                </Link>
                <Link
                  to="/services/trademark-search"
                  className="text-sm text-gray-300 hover:text-[#fd5a27]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Trademark Search
                </Link>
                <Link
                  to="/services/amazon-brand-registry"
                  className="text-sm text-gray-300 hover:text-[#fd5a27]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Amazon Brand Registry
                </Link>
              </div>
              <Link
                to="/about"
                className="text-sm font-medium text-gray-200 hover:text-[#fd5a27]"
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <Link
                to="/contact"
                className="text-sm font-medium text-gray-200 hover:text-[#fd5a27]"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact Us
              </Link>
              <Button className="chat bg-[#fd5a27] hover:bg-[#e04a1f] text-white w-full">
                Live Chat
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
